import { render } from "./Voting.vue?vue&type=template&id=559562b6&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"

import "./Voting.vue?vue&type=style&index=0&id=559562b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559562b6"]])

export default __exports__